import React from "react";
import Styles from './styles.module.css';
import '../../auth/login/tokens.css';

const Pages404: React.FC = () => {

  return (
    <>
    <div className={Styles.container}>
      <div className={Styles.spinner}></div>

      <p className={Styles.p}>現在、データ取得中...</p>

      <button className={Styles.button}
      onClick={() => {
        window.location.href = "https://memorii-works.com/company/login";
      }}>ログイン画面に戻る</button>
    </div>
    </>
  );
}

export default Pages404;
